import moment from 'moment';
import get from 'lodash/get';
import merge from 'lodash/merge';
import invert from 'lodash/invert';
import isDate from 'lodash/isDate';
import isUndefined from 'lodash/isUndefined';
import mapKeys from 'lodash/mapKeys';
import pick from 'lodash/pick';
import mapValues from 'lodash/mapValues';
import pickBy from 'lodash/pickBy';
import omitBy from 'lodash/omitBy';
import omit from 'lodash/omit';

const URL_PARAMS = [
  'address', 'zoom', 'space_type_ids',
  'listing_feature_ids', 'listing_feature_ids_contains_array',
  'project_type_ids', 'parent_project_type_id', 'position_types',
  'latitude_gteq', 'latitude_lteq', 'longitude_gteq', 'longitude_lteq',
  'latitude', 'longitude', 'daily_price_gteq', 'daily_price_lteq',
  'weekly_price_gteq', 'weekly_price_lteq',
  'monthly_price_gteq', 'monthly_price_lteq',
  'lat_g', 'lat_l', 'lng_g', 'lng_l', 'parent_project_type_ids_contains_element',
  'size_gteq', 'size_lteq', 's', 'country', 'city',
  'duration', 'start_date', 'end_date', 'fit_bounds', 'foot_traffic',
  'is_for_lease', 'is_for_revenue_share', 'is_for_sale', 'is_for_short_term',
];

const LOCATION_TO_PARAMS = {
  lat_g: 'latitude_gteq',
  lat_l: 'latitude_lteq',
  lng_g: 'longitude_gteq',
  lng_l: 'longitude_lteq',
  listing_feature_ids: 'listing_feature_ids_contains_array',
};

const PARAMS_TO_LOCATION = invert(LOCATION_TO_PARAMS);

function mapParams(params, mapping) {
  const mapped = mapKeys(params, (_value, param) => get(mapping, param, param));
  return pick(mapped, URL_PARAMS);
}

function paramsToLocation(params) {
  return mapParams(params, PARAMS_TO_LOCATION);
}

function locationToParams(location) {
  return mapParams(location, LOCATION_TO_PARAMS);
}

function datesToParams(params) {
  return mapValues(params, (value) => (
      isDate(value)
        ? moment.utc(value).local().format('YYYY-MM-DD')
        : value
    ));
}

function update(oldParams, newParams) {
  const merged = merge({}, oldParams, newParams);
  const withoutUndefined = pickBy(merged, (value) => !isUndefined(value));
  const withoutNull = omitBy(withoutUndefined, (value) => value === null);
  return omit(withoutNull, '_');
}

export const toUrlParams = function (filters, page) {
  return merge(paramsToLocation(filters), { page });
};

export const toFilters = function (oldParams, newParams) {
  return update(oldParams, locationToParams(datesToParams(newParams)));
};
